import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const containerStyle: CSSProperties = {
  width: '100%',
  maxHeight: '80vh',
  borderTopLeftRadius: UIConfig.Card.Content.borderRadius,
  borderTopRightRadius: UIConfig.Card.Content.borderRadius,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  background: '#FFF',
  overflowY: 'auto'
};

export const contentStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flex: 1
};

export const textContainerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center'
};

export const textStyle: CSSProperties = {
  fontSize: '23px',
  letterSpacing: '0.5px',
  color: '#000',
  lineHeight: '1.2',
  textAlign: 'center',
  fontWeight: 'bold',
  paddingLeft: 20,
  paddingRight: 20
};

export const subTextStyle: CSSProperties = {
  fontSize: '14px',
  color: 'rgb(53, 51, 51)',
  margin: '5px 0 15px 0',
  textAlign: 'center',
  maxWidth: '90%'
};

export const benefitStyle: CSSProperties = {
  color: '#000',
  display: 'flex',
  fontWeight: 'bold',
  alignItems: 'center',
  justifyContent: 'flex-start',
  marginTop: '15px',
  gap: '10px',
  width: '80%',
  marginLeft: 60
};

export const noteContainerStyle: CSSProperties = {
  color: 'rgb(111, 109, 109)',
  fontSize: '14px',
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingLeft: 20,
  paddingRight: 20
};

export const noteTextStyle: CSSProperties = {
  padding: '2px',
  margin: 0,
  textAlign: 'left',
  marginLeft: '10px'
};
